import { render } from "./NewProfile.vue?vue&type=template&id=0509babf"
import script from "./NewProfile.vue?vue&type=script&lang=js"
export * from "./NewProfile.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/profile/NewProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0509babf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0509babf', __exports__)) {
    console.log('reload')
    api.reload('0509babf', __exports__)
  }
  
  module.hot.accept("./NewProfile.vue?vue&type=template&id=0509babf", () => {
    console.log('re-render')
    api.rerender('0509babf', render)
  })

}


export default __exports__